<dashboard-dialog-frame class="follow-up-viewer-dialog" [header]="headerName()" [actions]="actions()" [dialogRef]="dialogRef">

	<kendo-tabstrip id="engagementViewerTabStrip" class="p-2 pb-0 h-100">

		<kendo-tabstrip-tab title="Details" [selected]="true">
			<ng-template kendoTabContent>
				<follow-up-details-part></follow-up-details-part>
			</ng-template>
		</kendo-tabstrip-tab>

	</kendo-tabstrip>

</dashboard-dialog-frame>